import getLoggedAtWorkoutUtil from '../../../../../modules/workout/model/utils/get-logged-at'

function isLoggedWorkoutUtil (workout) {
  return !!getLoggedAtWorkoutUtil(workout)
}

export default isLoggedWorkoutUtil
